// Inverse of CardConverter: the serializable CardData a live card was built from
const CardToData = (card) => card?.cardData ?? null;

module.exports = CardToData;
